var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCurveFooterMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 355 42"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ECF6F1",
  d: "M0 41.857h355v-25.38s-115-30.944-177.5-5.723S0 18.965 0 18.965z"
})));
export default SvgCurveFooterMobile;